<template>
  <div class="b_s_match_box">
    <div class="team_name">
      <div class="home"><span>{{homeTeamName}}</span></div>
      <div class="vs"><span>VS</span></div>
      <div class="away"><span>{{awayTeamName}}</span></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "LeisureGameMathBoxComp",
    props:{
      homeTeamName:{
        type:String,
        default(){
          return ''
        }
      },
      awayTeamName:{
        type:String,
        default(){
          return ''
        }
      }
    }
  }
</script>

<style scoped>

</style>